import { ISeoSpeciesFamilySpecie } from './types';

export const TOP_SEARCHED_SPECIES: ISeoSpeciesFamilySpecie[] = [
  { commonName: 'Channel catfish', externalId: 'YFnGM91z' },
  { commonName: 'Common carp', externalId: 'grgTynoB' },
  { commonName: 'Bluegill', externalId: 'tksu1kIP' },
  { commonName: 'Northern Pike', externalId: 'HSc8zwDz' },
  { commonName: 'Rainbow Trout', externalId: 'vseSW7xa' },
  { commonName: 'Striped Bass', externalId: 'gOVMRtUl' },
  { commonName: 'Walleye', externalId: 'dPcNM0o4' },
  { commonName: 'Alligator Gar', externalId: 'yZ0YDOZ8' },
  { commonName: 'White Sturgeon', externalId: 'ltTDfGT6' },
  { commonName: 'Smallmouth Bass', externalId: 'qwLoGLjq' },
  { commonName: 'Longnose Gar', externalId: 'uzlUStXY' },
  { commonName: 'Black Bullhead', externalId: 'UQZDqqXU' },
];
